import React from "react";
import styled from "@emotion/styled";
import {css} from "@mui/material/styles";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {ILocalizationController} from "views/controllers/localization/localization.controller";

const Wrapper = styled.div<IProps>`
	color: #1c1c1e;
	font-size: 10px;
	font-style: normal;
	font-weight: 600;
	line-height: 130%;
	padding: 0 4px;
	border-radius: 2px;
	background: linear-gradient(180deg, #21cfdc 0%, #99fe88 100%);
	text-align: center;
	${(props) =>
		props.isPending &&
		css`
			color: #d9dee4;
			border-radius: 2px;
			background: #282f38;
		`}
`;

interface IProps {
	isPending: boolean;
}

export const FriendTitle: React.FC<IProps> = observer(({isPending}) => {
	const {i18n} = useViewController<ILocalizationController>(Bindings.LocalizationController);
	return (
		<Wrapper isPending={isPending}>
			{isPending
				? i18n.t("h2h.friends_badge.friend_pending", "Friend pending")
				: i18n.t("h2h.friends_badge.friend", "Friend")}
		</Wrapper>
	);
});
